import { Box, Button, ButtonGroup, Drawer, Stack, Typography } from "@mui/material";
import IncidentTimeline from "./IncidentTimeline";
import { useTranslation } from "react-i18next";

const IncidentDetailDrawer = ({ open, incident, timeline = [], onClose }) => {
  const { t } = useTranslation();
  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: "100%", md: 520 }, p: 3 } }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h4">{incident?.title || t("platform.common.incident")}</Typography>
          <Typography variant="body2" color="text.secondary">{incident?.id} · {incident?.status}</Typography>
        </Box>
        <Box sx={{ aspectRatio: "16 / 9", bgcolor: "#020617", borderRadius: 1, display: "grid", placeItems: "center" }}>
          <Typography color="rgba(226,232,240,0.7)">{t("platform.evidence.preview")}</Typography>
        </Box>
        <ButtonGroup variant="outlined" size="small" sx={{ display: "flex", flexWrap: "wrap", gap: 1, "& .MuiButton-root": { border: "1px solid", borderColor: "divider", borderRadius: "8px !important" } }}>
          <Button>{t("platform.feedback.confirmedTheft")}</Button>
          <Button>{t("platform.feedback.falsePositive")}</Button>
          <Button>{t("platform.feedback.suspicious")}</Button>
          <Button>{t("platform.feedback.notSure")}</Button>
        </ButtonGroup>
        <IncidentTimeline items={timeline} />
        <Button variant="contained" onClick={onClose}>{t("common.close")}</Button>
      </Stack>
    </Drawer>
  );
};

export default IncidentDetailDrawer;
